// ** Next imports
import Image from "next/image";

// ** File imports
import Layout, { SEOHead } from "../../layouts/default";
import { FaqTemplate, FaqH, FaqP } from "../../components/support/faqPages";

// ** Img Imports
import cp1Img from "../../../public/images/cp1.png";
import cp2Img from "../../../public/images/cp2.png";

const AccessCustomerPortal = () => (
  <Layout>
    <SEOHead title="Access Customer Portal - EIN" />
    <FaqTemplate title="Accessing The Customer Portal">
      <FaqH>When can I access the Customer Portal?</FaqH>
      <FaqP>
        When your installation is complete you will be sent an email inviting
        you to access your Customer Portal. In the Customer Portal you can view
        your billing history, payment history, account information, and add a
        card to file for autopay.
      </FaqP>
      <FaqH>Where do I access the Customer Portal?</FaqH>
      <FaqP>
        You can access the Customer Portal anytime by going to the EIN homepage
        and clicking on the Customer Portal link at the top of left of the page.
      </FaqP>

      <hr />
      <Image
        src={cp1Img}
        className="img-fluid"
        placeholder="blur"
        alt="Customer Portal Menu"
      />
      <hr />

      <FaqP>
        This will open the Customer Portal homepage, where you will find an
        option to log in to securely access your account information and
        history, as well as forms for quick access to the most common account
        requests.
      </FaqP>

      <hr />
      <Image
        src={cp2Img}
        className="img-fluid"
        placeholder="blur"
        alt="Customer Portal Options"
      />
      <hr />
      <FaqH>How do I reset or change my Customer Portal password?</FaqH>
      <FaqP>
        If you need to reset your Customer Portal password please go to the
        login page at
        <a
          href={`https://my.easyinternetnow.com/portal/easyinternetnow/login`}
          target="_blank"
          rel="noopener noreferrer"
        >
          https://my.easyinternetnow.com/portal/easyinternetnow/login
        </a>{" "}
        and click the &#8216;Forgot Password?&#8217; text link below the login
        fields. You&#8217;ll need to provide the email you used when signing up
        with EIN (or the email on file if you&#8217;ve changed your email
        address in our system). You&#8217;ll receive an email with a link to set
        a new password.
      </FaqP>
    </FaqTemplate>
  </Layout>
);

export default AccessCustomerPortal;
